import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import AdditionalServiceDiscountCampaignContainer from 'app/containers/Marketing/DiscountCampaignManagement/AdditionalServiceCampaign'

const AdditionalServiceDiscountCampaignPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.additional_campaign)}</PageTitle>
      <AdditionalServiceDiscountCampaignContainer />
    </>
  )
}
const AdditionalServiceDiscountCampaignPage = memo(
  AdditionalServiceDiscountCampaignPageCpn,
  isEqual,
)

export default AdditionalServiceDiscountCampaignPage
